/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as PreviewTokenRouteImport } from './routes/preview.$token'
import { Route as AuthenticatedToolsRouteImport } from './routes/_authenticated/tools'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedWebhooksIndexRouteImport } from './routes/_authenticated/webhooks/index'
import { Route as AuthenticatedVideosIndexRouteImport } from './routes/_authenticated/videos/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTagsIndexRouteImport } from './routes/_authenticated/tags/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedPromosIndexRouteImport } from './routes/_authenticated/promos/index'
import { Route as AuthenticatedPostsIndexRouteImport } from './routes/_authenticated/posts/index'
import { Route as AuthenticatedPagesIndexRouteImport } from './routes/_authenticated/pages/index'
import { Route as AuthenticatedMediaIndexRouteImport } from './routes/_authenticated/media/index'
import { Route as AuthenticatedHomepageIndexRouteImport } from './routes/_authenticated/homepage/index'
import { Route as AuthenticatedGroupContentsIndexRouteImport } from './routes/_authenticated/group-contents/index'
import { Route as AuthenticatedFeedSourcesIndexRouteImport } from './routes/_authenticated/feed-sources/index'
import { Route as AuthenticatedCommentsIndexRouteImport } from './routes/_authenticated/comments/index'
import { Route as AuthenticatedCategoriesIndexRouteImport } from './routes/_authenticated/categories/index'
import { Route as AuthenticatedAuditIndexRouteImport } from './routes/_authenticated/audit/index'
import { Route as AuthenticatedVideosPlaylistIdRouteImport } from './routes/_authenticated/videos/$playlistId'
import { Route as AuthenticatedPromosNewRouteImport } from './routes/_authenticated/promos/new'
import { Route as AuthenticatedPostsNewRouteImport } from './routes/_authenticated/posts/new'
import { Route as AuthenticatedPostsPostIdRouteImport } from './routes/_authenticated/posts/$postId'
import { Route as AuthenticatedPagesNewRouteImport } from './routes/_authenticated/pages/new'
import { Route as AuthenticatedGroupContentsNewRouteImport } from './routes/_authenticated/group-contents/new'
import { Route as AuthenticatedPromosIdEditRouteImport } from './routes/_authenticated/promos/$id.edit'
import { Route as AuthenticatedPagesIdEditRouteImport } from './routes/_authenticated/pages/$id.edit'
import { Route as AuthenticatedGroupContentsIdEditRouteImport } from './routes/_authenticated/group-contents/$id.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PreviewTokenRoute = PreviewTokenRouteImport.update({
  id: '/preview/$token',
  path: '/preview/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedToolsRoute = AuthenticatedToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWebhooksIndexRoute =
  AuthenticatedWebhooksIndexRouteImport.update({
    id: '/webhooks/',
    path: '/webhooks/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVideosIndexRoute =
  AuthenticatedVideosIndexRouteImport.update({
    id: '/videos/',
    path: '/videos/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTagsIndexRoute = AuthenticatedTagsIndexRouteImport.update({
  id: '/tags/',
  path: '/tags/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPromosIndexRoute =
  AuthenticatedPromosIndexRouteImport.update({
    id: '/promos/',
    path: '/promos/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPostsIndexRoute = AuthenticatedPostsIndexRouteImport.update({
  id: '/posts/',
  path: '/posts/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPagesIndexRoute = AuthenticatedPagesIndexRouteImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMediaIndexRoute = AuthenticatedMediaIndexRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomepageIndexRoute =
  AuthenticatedHomepageIndexRouteImport.update({
    id: '/homepage/',
    path: '/homepage/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupContentsIndexRoute =
  AuthenticatedGroupContentsIndexRouteImport.update({
    id: '/group-contents/',
    path: '/group-contents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFeedSourcesIndexRoute =
  AuthenticatedFeedSourcesIndexRouteImport.update({
    id: '/feed-sources/',
    path: '/feed-sources/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCommentsIndexRoute =
  AuthenticatedCommentsIndexRouteImport.update({
    id: '/comments/',
    path: '/comments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCategoriesIndexRoute =
  AuthenticatedCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditIndexRoute = AuthenticatedAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVideosPlaylistIdRoute =
  AuthenticatedVideosPlaylistIdRouteImport.update({
    id: '/videos/$playlistId',
    path: '/videos/$playlistId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromosNewRoute = AuthenticatedPromosNewRouteImport.update({
  id: '/promos/new',
  path: '/promos/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPostsNewRoute = AuthenticatedPostsNewRouteImport.update({
  id: '/posts/new',
  path: '/posts/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPostsPostIdRoute =
  AuthenticatedPostsPostIdRouteImport.update({
    id: '/posts/$postId',
    path: '/posts/$postId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPagesNewRoute = AuthenticatedPagesNewRouteImport.update({
  id: '/pages/new',
  path: '/pages/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGroupContentsNewRoute =
  AuthenticatedGroupContentsNewRouteImport.update({
    id: '/group-contents/new',
    path: '/group-contents/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromosIdEditRoute =
  AuthenticatedPromosIdEditRouteImport.update({
    id: '/promos/$id/edit',
    path: '/promos/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPagesIdEditRoute =
  AuthenticatedPagesIdEditRouteImport.update({
    id: '/pages/$id/edit',
    path: '/pages/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupContentsIdEditRoute =
  AuthenticatedGroupContentsIdEditRouteImport.update({
    id: '/group-contents/$id/edit',
    path: '/group-contents/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/tools': typeof AuthenticatedToolsRoute
  '/preview/$token': typeof PreviewTokenRoute
  '/group-contents/new': typeof AuthenticatedGroupContentsNewRoute
  '/pages/new': typeof AuthenticatedPagesNewRoute
  '/posts/$postId': typeof AuthenticatedPostsPostIdRoute
  '/posts/new': typeof AuthenticatedPostsNewRoute
  '/promos/new': typeof AuthenticatedPromosNewRoute
  '/videos/$playlistId': typeof AuthenticatedVideosPlaylistIdRoute
  '/audit/': typeof AuthenticatedAuditIndexRoute
  '/categories/': typeof AuthenticatedCategoriesIndexRoute
  '/comments/': typeof AuthenticatedCommentsIndexRoute
  '/feed-sources/': typeof AuthenticatedFeedSourcesIndexRoute
  '/group-contents/': typeof AuthenticatedGroupContentsIndexRoute
  '/homepage/': typeof AuthenticatedHomepageIndexRoute
  '/media/': typeof AuthenticatedMediaIndexRoute
  '/pages/': typeof AuthenticatedPagesIndexRoute
  '/posts/': typeof AuthenticatedPostsIndexRoute
  '/promos/': typeof AuthenticatedPromosIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tags/': typeof AuthenticatedTagsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/videos/': typeof AuthenticatedVideosIndexRoute
  '/webhooks/': typeof AuthenticatedWebhooksIndexRoute
  '/group-contents/$id/edit': typeof AuthenticatedGroupContentsIdEditRoute
  '/pages/$id/edit': typeof AuthenticatedPagesIdEditRoute
  '/promos/$id/edit': typeof AuthenticatedPromosIdEditRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/tools': typeof AuthenticatedToolsRoute
  '/preview/$token': typeof PreviewTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/group-contents/new': typeof AuthenticatedGroupContentsNewRoute
  '/pages/new': typeof AuthenticatedPagesNewRoute
  '/posts/$postId': typeof AuthenticatedPostsPostIdRoute
  '/posts/new': typeof AuthenticatedPostsNewRoute
  '/promos/new': typeof AuthenticatedPromosNewRoute
  '/videos/$playlistId': typeof AuthenticatedVideosPlaylistIdRoute
  '/audit': typeof AuthenticatedAuditIndexRoute
  '/categories': typeof AuthenticatedCategoriesIndexRoute
  '/comments': typeof AuthenticatedCommentsIndexRoute
  '/feed-sources': typeof AuthenticatedFeedSourcesIndexRoute
  '/group-contents': typeof AuthenticatedGroupContentsIndexRoute
  '/homepage': typeof AuthenticatedHomepageIndexRoute
  '/media': typeof AuthenticatedMediaIndexRoute
  '/pages': typeof AuthenticatedPagesIndexRoute
  '/posts': typeof AuthenticatedPostsIndexRoute
  '/promos': typeof AuthenticatedPromosIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tags': typeof AuthenticatedTagsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/videos': typeof AuthenticatedVideosIndexRoute
  '/webhooks': typeof AuthenticatedWebhooksIndexRoute
  '/group-contents/$id/edit': typeof AuthenticatedGroupContentsIdEditRoute
  '/pages/$id/edit': typeof AuthenticatedPagesIdEditRoute
  '/promos/$id/edit': typeof AuthenticatedPromosIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/tools': typeof AuthenticatedToolsRoute
  '/preview/$token': typeof PreviewTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/group-contents/new': typeof AuthenticatedGroupContentsNewRoute
  '/_authenticated/pages/new': typeof AuthenticatedPagesNewRoute
  '/_authenticated/posts/$postId': typeof AuthenticatedPostsPostIdRoute
  '/_authenticated/posts/new': typeof AuthenticatedPostsNewRoute
  '/_authenticated/promos/new': typeof AuthenticatedPromosNewRoute
  '/_authenticated/videos/$playlistId': typeof AuthenticatedVideosPlaylistIdRoute
  '/_authenticated/audit/': typeof AuthenticatedAuditIndexRoute
  '/_authenticated/categories/': typeof AuthenticatedCategoriesIndexRoute
  '/_authenticated/comments/': typeof AuthenticatedCommentsIndexRoute
  '/_authenticated/feed-sources/': typeof AuthenticatedFeedSourcesIndexRoute
  '/_authenticated/group-contents/': typeof AuthenticatedGroupContentsIndexRoute
  '/_authenticated/homepage/': typeof AuthenticatedHomepageIndexRoute
  '/_authenticated/media/': typeof AuthenticatedMediaIndexRoute
  '/_authenticated/pages/': typeof AuthenticatedPagesIndexRoute
  '/_authenticated/posts/': typeof AuthenticatedPostsIndexRoute
  '/_authenticated/promos/': typeof AuthenticatedPromosIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tags/': typeof AuthenticatedTagsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/videos/': typeof AuthenticatedVideosIndexRoute
  '/_authenticated/webhooks/': typeof AuthenticatedWebhooksIndexRoute
  '/_authenticated/group-contents/$id/edit': typeof AuthenticatedGroupContentsIdEditRoute
  '/_authenticated/pages/$id/edit': typeof AuthenticatedPagesIdEditRoute
  '/_authenticated/promos/$id/edit': typeof AuthenticatedPromosIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/account'
    | '/tools'
    | '/preview/$token'
    | '/group-contents/new'
    | '/pages/new'
    | '/posts/$postId'
    | '/posts/new'
    | '/promos/new'
    | '/videos/$playlistId'
    | '/audit/'
    | '/categories/'
    | '/comments/'
    | '/feed-sources/'
    | '/group-contents/'
    | '/homepage/'
    | '/media/'
    | '/pages/'
    | '/posts/'
    | '/promos/'
    | '/roles/'
    | '/settings/'
    | '/tags/'
    | '/users/'
    | '/videos/'
    | '/webhooks/'
    | '/group-contents/$id/edit'
    | '/pages/$id/edit'
    | '/promos/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/account'
    | '/tools'
    | '/preview/$token'
    | '/'
    | '/group-contents/new'
    | '/pages/new'
    | '/posts/$postId'
    | '/posts/new'
    | '/promos/new'
    | '/videos/$playlistId'
    | '/audit'
    | '/categories'
    | '/comments'
    | '/feed-sources'
    | '/group-contents'
    | '/homepage'
    | '/media'
    | '/pages'
    | '/posts'
    | '/promos'
    | '/roles'
    | '/settings'
    | '/tags'
    | '/users'
    | '/videos'
    | '/webhooks'
    | '/group-contents/$id/edit'
    | '/pages/$id/edit'
    | '/promos/$id/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/account'
    | '/_authenticated/tools'
    | '/preview/$token'
    | '/_authenticated/'
    | '/_authenticated/group-contents/new'
    | '/_authenticated/pages/new'
    | '/_authenticated/posts/$postId'
    | '/_authenticated/posts/new'
    | '/_authenticated/promos/new'
    | '/_authenticated/videos/$playlistId'
    | '/_authenticated/audit/'
    | '/_authenticated/categories/'
    | '/_authenticated/comments/'
    | '/_authenticated/feed-sources/'
    | '/_authenticated/group-contents/'
    | '/_authenticated/homepage/'
    | '/_authenticated/media/'
    | '/_authenticated/pages/'
    | '/_authenticated/posts/'
    | '/_authenticated/promos/'
    | '/_authenticated/roles/'
    | '/_authenticated/settings/'
    | '/_authenticated/tags/'
    | '/_authenticated/users/'
    | '/_authenticated/videos/'
    | '/_authenticated/webhooks/'
    | '/_authenticated/group-contents/$id/edit'
    | '/_authenticated/pages/$id/edit'
    | '/_authenticated/promos/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  PreviewTokenRoute: typeof PreviewTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/preview/$token': {
      id: '/preview/$token'
      path: '/preview/$token'
      fullPath: '/preview/$token'
      preLoaderRoute: typeof PreviewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/tools': {
      id: '/_authenticated/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof AuthenticatedToolsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/webhooks/': {
      id: '/_authenticated/webhooks/'
      path: '/webhooks'
      fullPath: '/webhooks/'
      preLoaderRoute: typeof AuthenticatedWebhooksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/videos/': {
      id: '/_authenticated/videos/'
      path: '/videos'
      fullPath: '/videos/'
      preLoaderRoute: typeof AuthenticatedVideosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tags/': {
      id: '/_authenticated/tags/'
      path: '/tags'
      fullPath: '/tags/'
      preLoaderRoute: typeof AuthenticatedTagsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/promos/': {
      id: '/_authenticated/promos/'
      path: '/promos'
      fullPath: '/promos/'
      preLoaderRoute: typeof AuthenticatedPromosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/posts/': {
      id: '/_authenticated/posts/'
      path: '/posts'
      fullPath: '/posts/'
      preLoaderRoute: typeof AuthenticatedPostsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pages/': {
      id: '/_authenticated/pages/'
      path: '/pages'
      fullPath: '/pages/'
      preLoaderRoute: typeof AuthenticatedPagesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/media/': {
      id: '/_authenticated/media/'
      path: '/media'
      fullPath: '/media/'
      preLoaderRoute: typeof AuthenticatedMediaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/homepage/': {
      id: '/_authenticated/homepage/'
      path: '/homepage'
      fullPath: '/homepage/'
      preLoaderRoute: typeof AuthenticatedHomepageIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/group-contents/': {
      id: '/_authenticated/group-contents/'
      path: '/group-contents'
      fullPath: '/group-contents/'
      preLoaderRoute: typeof AuthenticatedGroupContentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feed-sources/': {
      id: '/_authenticated/feed-sources/'
      path: '/feed-sources'
      fullPath: '/feed-sources/'
      preLoaderRoute: typeof AuthenticatedFeedSourcesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/comments/': {
      id: '/_authenticated/comments/'
      path: '/comments'
      fullPath: '/comments/'
      preLoaderRoute: typeof AuthenticatedCommentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/categories/': {
      id: '/_authenticated/categories/'
      path: '/categories'
      fullPath: '/categories/'
      preLoaderRoute: typeof AuthenticatedCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/': {
      id: '/_authenticated/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuthenticatedAuditIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/videos/$playlistId': {
      id: '/_authenticated/videos/$playlistId'
      path: '/videos/$playlistId'
      fullPath: '/videos/$playlistId'
      preLoaderRoute: typeof AuthenticatedVideosPlaylistIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/promos/new': {
      id: '/_authenticated/promos/new'
      path: '/promos/new'
      fullPath: '/promos/new'
      preLoaderRoute: typeof AuthenticatedPromosNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/posts/new': {
      id: '/_authenticated/posts/new'
      path: '/posts/new'
      fullPath: '/posts/new'
      preLoaderRoute: typeof AuthenticatedPostsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/posts/$postId': {
      id: '/_authenticated/posts/$postId'
      path: '/posts/$postId'
      fullPath: '/posts/$postId'
      preLoaderRoute: typeof AuthenticatedPostsPostIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pages/new': {
      id: '/_authenticated/pages/new'
      path: '/pages/new'
      fullPath: '/pages/new'
      preLoaderRoute: typeof AuthenticatedPagesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/group-contents/new': {
      id: '/_authenticated/group-contents/new'
      path: '/group-contents/new'
      fullPath: '/group-contents/new'
      preLoaderRoute: typeof AuthenticatedGroupContentsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/promos/$id/edit': {
      id: '/_authenticated/promos/$id/edit'
      path: '/promos/$id/edit'
      fullPath: '/promos/$id/edit'
      preLoaderRoute: typeof AuthenticatedPromosIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pages/$id/edit': {
      id: '/_authenticated/pages/$id/edit'
      path: '/pages/$id/edit'
      fullPath: '/pages/$id/edit'
      preLoaderRoute: typeof AuthenticatedPagesIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/group-contents/$id/edit': {
      id: '/_authenticated/group-contents/$id/edit'
      path: '/group-contents/$id/edit'
      fullPath: '/group-contents/$id/edit'
      preLoaderRoute: typeof AuthenticatedGroupContentsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedToolsRoute: typeof AuthenticatedToolsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedGroupContentsNewRoute: typeof AuthenticatedGroupContentsNewRoute
  AuthenticatedPagesNewRoute: typeof AuthenticatedPagesNewRoute
  AuthenticatedPostsPostIdRoute: typeof AuthenticatedPostsPostIdRoute
  AuthenticatedPostsNewRoute: typeof AuthenticatedPostsNewRoute
  AuthenticatedPromosNewRoute: typeof AuthenticatedPromosNewRoute
  AuthenticatedVideosPlaylistIdRoute: typeof AuthenticatedVideosPlaylistIdRoute
  AuthenticatedAuditIndexRoute: typeof AuthenticatedAuditIndexRoute
  AuthenticatedCategoriesIndexRoute: typeof AuthenticatedCategoriesIndexRoute
  AuthenticatedCommentsIndexRoute: typeof AuthenticatedCommentsIndexRoute
  AuthenticatedFeedSourcesIndexRoute: typeof AuthenticatedFeedSourcesIndexRoute
  AuthenticatedGroupContentsIndexRoute: typeof AuthenticatedGroupContentsIndexRoute
  AuthenticatedHomepageIndexRoute: typeof AuthenticatedHomepageIndexRoute
  AuthenticatedMediaIndexRoute: typeof AuthenticatedMediaIndexRoute
  AuthenticatedPagesIndexRoute: typeof AuthenticatedPagesIndexRoute
  AuthenticatedPostsIndexRoute: typeof AuthenticatedPostsIndexRoute
  AuthenticatedPromosIndexRoute: typeof AuthenticatedPromosIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedTagsIndexRoute: typeof AuthenticatedTagsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedVideosIndexRoute: typeof AuthenticatedVideosIndexRoute
  AuthenticatedWebhooksIndexRoute: typeof AuthenticatedWebhooksIndexRoute
  AuthenticatedGroupContentsIdEditRoute: typeof AuthenticatedGroupContentsIdEditRoute
  AuthenticatedPagesIdEditRoute: typeof AuthenticatedPagesIdEditRoute
  AuthenticatedPromosIdEditRoute: typeof AuthenticatedPromosIdEditRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedToolsRoute: AuthenticatedToolsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedGroupContentsNewRoute: AuthenticatedGroupContentsNewRoute,
  AuthenticatedPagesNewRoute: AuthenticatedPagesNewRoute,
  AuthenticatedPostsPostIdRoute: AuthenticatedPostsPostIdRoute,
  AuthenticatedPostsNewRoute: AuthenticatedPostsNewRoute,
  AuthenticatedPromosNewRoute: AuthenticatedPromosNewRoute,
  AuthenticatedVideosPlaylistIdRoute: AuthenticatedVideosPlaylistIdRoute,
  AuthenticatedAuditIndexRoute: AuthenticatedAuditIndexRoute,
  AuthenticatedCategoriesIndexRoute: AuthenticatedCategoriesIndexRoute,
  AuthenticatedCommentsIndexRoute: AuthenticatedCommentsIndexRoute,
  AuthenticatedFeedSourcesIndexRoute: AuthenticatedFeedSourcesIndexRoute,
  AuthenticatedGroupContentsIndexRoute: AuthenticatedGroupContentsIndexRoute,
  AuthenticatedHomepageIndexRoute: AuthenticatedHomepageIndexRoute,
  AuthenticatedMediaIndexRoute: AuthenticatedMediaIndexRoute,
  AuthenticatedPagesIndexRoute: AuthenticatedPagesIndexRoute,
  AuthenticatedPostsIndexRoute: AuthenticatedPostsIndexRoute,
  AuthenticatedPromosIndexRoute: AuthenticatedPromosIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTagsIndexRoute: AuthenticatedTagsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedVideosIndexRoute: AuthenticatedVideosIndexRoute,
  AuthenticatedWebhooksIndexRoute: AuthenticatedWebhooksIndexRoute,
  AuthenticatedGroupContentsIdEditRoute: AuthenticatedGroupContentsIdEditRoute,
  AuthenticatedPagesIdEditRoute: AuthenticatedPagesIdEditRoute,
  AuthenticatedPromosIdEditRoute: AuthenticatedPromosIdEditRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  PreviewTokenRoute: PreviewTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
